/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceCategories } from '../models/ServiceCategories';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceCategoriesService {
    /**
     * returns all service categories
     * @returns ServiceCategories successful
     * @throws ApiError
     */
    public static getServiceCategories(): CancelablePromise<ServiceCategories> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/service_categories',
        });
    }
}
